import React, { useState } from 'react';
import { Row, Col, Card, Form, Button, InputGroup } from 'react-bootstrap';
import { templates } from '../../../helpers/';
import axios from 'axios';
import './AddNewTemplate.css';

import EmojiPicker from 'emoji-picker-react';

interface AddNewTemplateProps {
    newTemplateModal?: boolean;
    togglenewTemplateModal?: () => void;
    handleNewTemplate?: (values: any) => void;
    handleSubmit?: any;
    newTemplateDetails?: any;
    handleDateChange?: (date: Date) => void;
    errors?: any;
    control?: any;
    register?: any;
}

interface ButtonConfig {
    type: 'none' | 'call_to_action' | 'quick_reply';
    text?: string;
    phoneNumber?: string;
    url?: string;
    actionType?: 'SITE' | 'CALL';
}

const user = JSON.parse(sessionStorage.getItem('shreyu_user') || '{}')?.user?.id;

const AddNewTemplate: React.FC<AddNewTemplateProps> = ({ }: AddNewTemplateProps) => {
    const [headerType, setHeaderType] = useState<string>('None');
    const [headerText, setHeaderText] = useState<string>('');
    const [headerFile, setHeaderFile] = useState<File | null>(null);
    const [bodyText, setBodyText] = useState<string>('');
    const [footerText, setFooterText] = useState<string>('');
    const [variables, setVariables] = useState<string[]>([]);
    const [headervariables, setheaderVariables] = useState<string[]>([]);
    const [variableValues, setVariableValues] = useState<{ [key: string]: string }>({});
    const [headervariableValues, setheaderVariableValues] = useState<{ [key: string]: string }>({});
    const [buttons, setButtons] = useState<ButtonConfig[]>([]);
    const [newButtonText, setNewButtonText] = useState<string>('');
    const [newButtonType, setNewButtonType] = useState<'none' | 'call_to_action' | 'quick_reply'>('none');
    const [call_action_type, setCall_action_type] = useState<'SITE' | 'CALL'>('SITE');
    const [newButtonPhone, setNewButtonPhone] = useState<string>('');
    const [newButtonUrl, setNewButtonUrl] = useState<string>('');
    const [templateName, setTemplateName] = useState<string>('');
    const [language, setLanguage] = useState<string>('en_US');
    const [category, setCategory] = useState<'MARKETING' | 'UTILITY' | 'AUTHENTICATION'>('MARKETING');
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const [activeFormat, setActiveFormat] = useState<string | null>(null);

    const [successMessage, setSuccessMessage] = useState<string>('');

    const handleBodyChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const text = e.target.value;
        setBodyText(text);

        const vars = Array.from(new Set(text.match(/\{\{\d+\}\}/g) || []));
        setVariables(vars.slice(0, 10));

        const newValues = { ...variableValues };
        vars.forEach(v => {
            if (!newValues[v]) {
                newValues[v] = '';
            }
        });
        setVariableValues(newValues);
    };
    const handleheadChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const text = e.target.value;
        setHeaderText(text);

        const vars = Array.from(new Set(text.match(/\{\{\d+\}\}/g) || []));
        setheaderVariables(vars.slice(0, 1));

        const newValues = { ...headervariableValues };
        vars.forEach(v => {
            if (!newValues[v]) {
                newValues[v] = '';
            }
        });
        setheaderVariableValues(newValues);
    };

    const handleVariableChange = (variable: string, value: string) => {
        setVariableValues({
            ...variableValues,
            [variable]: value
        });
    };
    const handleheaderVariableChange = (variable: string, value: string) => {
        setheaderVariableValues({
            ...headervariableValues,
            [variable]: value
        });
    };

    const handleHeaderFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            setHeaderFile(e.target.files[0]);
        }
    };

    const addButton = () => {
        if (newButtonText.trim()) {
            // Check button limits
            const callToActionCount = buttons.filter(b => b.type === 'call_to_action').length;
            const siteButtonCount = buttons.filter(b => b.actionType === 'SITE').length;
            const callButtonCount = buttons.filter(b => b.actionType === 'CALL').length;

            if (newButtonType === 'call_to_action') {
                if (callToActionCount >= 2) {
                    alert('Maximum 2 call to action buttons allowed');
                    return;
                }
                if (call_action_type === 'SITE' && siteButtonCount >= 1) {
                    alert('Maximum 1 website URL button allowed');
                    return;
                }
                if (call_action_type === 'CALL' && callButtonCount >= 1) {
                    alert('Maximum 1 phone number button allowed');
                    return;
                }
            }

            let newButton: ButtonConfig = {
                type: newButtonType,
                text: newButtonText,
                actionType: newButtonType === 'call_to_action' ? call_action_type : undefined
            };

            if (newButtonType === 'call_to_action') {
                if (call_action_type === 'CALL' && newButtonPhone) {
                    newButton.phoneNumber = newButtonPhone;
                } else if (call_action_type === 'SITE' && newButtonUrl) {
                    newButton.url = newButtonUrl;
                }
            }

            setButtons([...buttons, newButton]);
            setNewButtonText('');
            setNewButtonPhone('');
            setNewButtonUrl('');
        }
    };

    const removeButton = (index: number) => {
        setButtons(buttons.filter((_, i) => i !== index));
    };

    const renderPreviewText = (text: string) => {
        if (!text) return '';
        let result = text;

        variables.forEach(v => {
            const regex = new RegExp(escapeRegExp(v), 'g');
            result = result.replace(regex, variableValues[v] || v);
        });

        result = result
            .replace(/\*(.*?)\*/g, '<strong>$1</strong>')
            .replace(/_(.*?)_/g, '<em>$1</em>')
            .replace(/~(.*?)~/g, '<span style="text-decoration: line-through">$1</span>')
            .replace(/\n/g, '<br/>');

        return result;
    };
    const renderHeaderPreviewText = (text: string) => {
        if (!text) return '';
        let result = text;

        headervariables.forEach(v => {
            const regex = new RegExp(escapeRegExp(v), 'g');
            result = result.replace(regex, headervariableValues[v] || v);
        });

        result = result
            .replace(/\*(.*?)\*/g, '<strong>$1</strong>')
            .replace(/_(.*?)_/g, '<em>$1</em>')
            .replace(/~(.*?)~/g, '<span style="text-decoration: line-through">$1</span>')
            .replace(/\n/g, '<br/>');

        return result;
    };

    const escapeRegExp = (string: string) => {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };

    const renderButtonPreview = (button: ButtonConfig, index: number) => {
        if (button.type === 'call_to_action') {
            return (
                <div key={index} className="whatsapp-call-to-action">
                    {button.phoneNumber ? (
                        <a href={`tel:${button.phoneNumber}`} className="whatsapp-call-button">
                            {button.text}
                        </a>
                    ) : button.url ? (
                        <a href={button.url} target="_blank" rel="noopener noreferrer" className="whatsapp-url-button" >
                            {button.text}
                        </a>
                    ) : null}
                </div>
            );
        } else if (button.type === 'quick_reply') {
            return (
                <div key={index} className="whatsapp-quick-reply">
                    <a className="whatsapp-quick-reply">
                        {button.text}
                    </a>
                </div>
            );
        }
        return null;
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        const formData = new FormData();

        formData.append('company_id', '2');
        formData.append('template_name', templateName);
        formData.append('language', language);
        formData.append('category', category);
        formData.append('title_type', headerType === 'None' ? 'none' : headerType.toLowerCase());

        if (headerType === 'TEXT') {
            formData.append('title', headerText);
        } else if (headerType !== 'None' && headerFile) {
            formData.append('title_file', headerFile);
        }

        formData.append('body', bodyText);
        formData.append('footer', footerText || '');

        if (variables.length > 0) {
            const variableArray = Object.values(variableValues);
            formData.append('variables', JSON.stringify(variableArray));
        }

        if (headervariables.length > 0) {
            const headervariableArray = Object.values(headervariableValues);
            formData.append('header_variables', JSON.stringify(headervariableArray));
        }

        if (buttons.length > 0) {
            buttons.forEach((button, index) => {
                if (button.type === 'call_to_action') {
                    formData.append(`type[${index}]`, 'call_to_action');
                    formData.append(`text[${index}]`, button.text || '');

                    if (button.url) {
                        formData.append(`call_to_action[${index}]`, 'visit site');
                        formData.append(`cat[${index}]`, button.url);
                    } else if (button.phoneNumber) {
                        formData.append(`call_to_action[${index}]`, 'call phone');
                        formData.append(`cat[${index}]`, button.phoneNumber);
                    }
                } else if (button.type === 'quick_reply') {
                    formData.append(`type[${index}]`, 'quick_reply');
                    formData.append(`text[${index}]`, button.text || '');
                }
            });
        }


        formData.append('wa_approval_status', 'Pending');
        formData.append('user_id', user);
        formData.append('status', 'Active');
        try {
            const response = await templates(formData);
            setSuccessMessage('Template created successfully!');
            setTimeout(() => {
                window.location.href = '/apps/templates/list';
            }, 2000);
        } catch (error) {
            console.error('Error creating template:', error);
        }
    };

    const applyFormatting = (format: string) => {
        const textarea = document.getElementById('bodyText') as HTMLTextAreaElement;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const selectedText = bodyText.substring(start, end);
        let newText = bodyText;
        const varNum = variables.length + 1;
        const newVar = `{{${varNum}}}`;

        switch (format) {
            case 'bold':
                newText = bodyText.substring(0, start) + `*${selectedText}*` + bodyText.substring(end);
                break;
            case 'italic':
                newText = bodyText.substring(0, start) + `_${selectedText}_` + bodyText.substring(end);
                break;
            case 'strikethrough':
                newText = bodyText.substring(0, start) + `~${selectedText}~` + bodyText.substring(end);
                break;
            case 'variable':
                const varNum = variables.length + 1;
                const newVar = `{{${varNum}}}`;
                newText = bodyText.substring(0, start) + newVar + bodyText.substring(end);
                setVariables([...variables, newVar]);
                break;
            default:
                break;
        }

        setBodyText(newText);
        setActiveFormat(format);
        setTimeout(() => {
            textarea.focus();
            textarea.setSelectionRange(
                format === 'variable' ? start + newVar.length :
                    start + (selectedText ? 1 : 0),
                format === 'variable' ? start + newVar.length :
                    end + (selectedText ? 1 : 0)
            );
        }, 0);
    };

    const onEmojiClick = (emojiData: any) => {
        const textarea = document.getElementById('bodyText') as HTMLTextAreaElement;
        const start = textarea.selectionStart;
        const newText = bodyText.substring(0, start) + emojiData.emoji + bodyText.substring(start);
        setBodyText(newText);
        setShowEmojiPicker(false);
        setTimeout(() => {
            textarea.focus();
            textarea.setSelectionRange(start + emojiData.emoji.length, start + emojiData.emoji.length);
        }, 0);
    };

    return (
        <Card className="border-0">
            <Row>
                <Col md={8}>
                    <Card.Header className="bg-secondary d-flex justify-content-between align-items-center">
                        <h5 className="mb-0 text-white">WhatsApp Template</h5>
                    </Card.Header>
                    <Card.Body className="p-4">
                        <h4 className="header-title mb-4">WhatsApp Template</h4>

                        <Form className="whatsapp-template-form" onSubmit={handleSubmit}  >
                            <Row className="mb-3">
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Template Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="hello_world"
                                            value={templateName}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTemplateName(e.target.value)}
                                            className="whatsapp-input"
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Language</Form.Label>
                                        <Form.Select
                                            className="whatsapp-input"
                                            value={language}
                                            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setLanguage(e.target.value)}
                                        >
                                            <option value="en_US">English (US)</option>
                                            <option value="en_GB">English (UK)</option>
                                            <option value="es_ES">Spanish</option>
                                            <option value="fr_FR">French</option>
                                            <option value="de_DE">German</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Category</Form.Label>
                                        <Form.Select
                                            className="whatsapp-input"
                                            value={category}
                                            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setCategory(e.target.value as "MARKETING" | "UTILITY" | "AUTHENTICATION")}                                        >
                                            <option value="MARKETING">Marketing</option>
                                            <option value="UTILITY">Utility</option>
                                            <option value="AUTHENTICATION">Authentication</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Header Type</Form.Label>
                                        <Form.Select
                                            className="whatsapp-input"
                                            value={headerType}
                                            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setHeaderType(e.target.value)}
                                        >
                                            <option value="None">None</option>
                                            <option value="TEXT">Text</option>
                                            <option value="IMAGE">Image</option>
                                            <option value="VIDEO">Video</option>
                                            <option value="DOCUMENT">Document</option>
                                            <option value="LOCATION">Location</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>

                            {headerType !== 'None' && (
                                <Row className="mb-3">
                                    <Col md={12}>
                                        <Form.Group>
                                            <Form.Label>
                                                {headerType === 'TEXT' ? 'Header Text' :
                                                    headerType === 'IMAGE' ? 'Upload Image' :
                                                        headerType === 'VIDEO' ? 'Upload Video' :
                                                            headerType === 'DOCUMENT' ? 'Upload Document' : 'Location Details'}
                                            </Form.Label>
                                            {headerType === 'TEXT' ? (
                                                <Form.Control
                                                    as="textarea"
                                                    rows={2}
                                                    className="whatsapp-input"
                                                    placeholder="Enter header text"
                                                    value={headerText}
                                                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                                                        handleheadChange(e);
                                                        setHeaderText(e.target.value);
                                                    }}
                                                />

                                            ) : (
                                                <Form.Control
                                                    type="file"
                                                    className="whatsapp-input"
                                                    onChange={handleHeaderFileChange}
                                                    accept={
                                                        headerType === 'IMAGE' ? 'image/*' :
                                                            headerType === 'VIDEO' ? 'video/*' :
                                                                headerType === 'DOCUMENT' ? '.pdf,.doc,.docx' : ''
                                                    }
                                                />
                                            )}
                                        </Form.Group>

                                    </Col>
                                </Row>

                            )}
                            {headervariables.length > 0 && (
                                <Row className="mb-3">
                                    <Col md={8}>
                                        <Form.Group>
                                            <Form.Label>Variable Values (for preview)</Form.Label>
                                            {headervariables.map((variable, index) => (
                                                <InputGroup key={index} className="mb-2">
                                                    <InputGroup.Text>{variable}</InputGroup.Text>
                                                    <Form.Control
                                                        type="text"
                                                        value={headervariableValues[variable] || ''}
                                                        onChange={(e) => handleheaderVariableChange(variable, e.target.value)}
                                                        placeholder={`Enter value for ${variable}`}
                                                    />
                                                </InputGroup>

                                            ))}
                                        </Form.Group>
                                    </Col>
                                </Row>
                            )}

                            <Row className="mb-3">
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label>Body</Form.Label>

                                        <Form.Control
                                            as="textarea"
                                            id="bodyText"
                                            rows={6}
                                            className="whatsapp-input whatsapp-body"
                                            value={bodyText}
                                            onChange={handleBodyChange}
                                            placeholder="Enter your message text. Use {{1}} for variables."
                                            required
                                        />
                                        <div className="whatsapp-formatting-toolbar mb-2" >
                                            <Button
                                                variant={activeFormat === 'bold' ? 'primary' : 'outline-secondary'}
                                                size="sm"
                                                onClick={() => applyFormatting('bold')}
                                                title="Bold (wrap with *)"
                                            >
                                                <strong>B</strong>
                                            </Button>
                                            <Button
                                                variant={activeFormat === 'italic' ? 'primary' : 'outline-secondary'}
                                                size="sm"
                                                onClick={() => applyFormatting('italic')}
                                                title="Italic (wrap with _)"
                                                className="mx-1"
                                            >
                                                <em>I</em>
                                            </Button>
                                            <Button
                                                variant={activeFormat === 'strikethrough' ? 'primary' : 'outline-secondary'}
                                                size="sm"
                                                onClick={() => applyFormatting('strikethrough')}
                                                title="Strikethrough (wrap with ~)"
                                            >
                                                <span style={{ textDecoration: 'line-through' }}>S</span>
                                            </Button>
                                            <Button
                                                variant="outline-secondary"
                                                size="sm"
                                                onClick={() => applyFormatting('variable')}
                                                title="Add variable"
                                                className="mx-1"
                                            >
                                                &#123;&#123;1&#125;&#125;
                                            </Button>
                                            <Button
                                                variant="outline-secondary"
                                                size="sm"
                                                onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                                                title="Add emoji"
                                            >
                                                😀
                                            </Button>
                                        </div>
                                        {showEmojiPicker && (
                                            <div className="emoji-picker-container">
                                                <EmojiPicker onEmojiClick={onEmojiClick} width={300} height={350} />
                                            </div>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>

                            {variables.length > 0 && (
                                <Row className="mb-3">
                                    <Col md={8}>
                                        <Form.Group>
                                            <Form.Label>Variable Values (for preview)</Form.Label>
                                            {variables.map((variable, index) => (
                                                <InputGroup key={index} className="mb-2">
                                                    <InputGroup.Text>{variable}</InputGroup.Text>
                                                    <Form.Control
                                                        type="text"
                                                        value={variableValues[variable] || ''}
                                                        onChange={(e) => handleVariableChange(variable, e.target.value)}
                                                        placeholder={`Enter value for ${variable}`}
                                                    />
                                                </InputGroup>
                                            ))}
                                        </Form.Group>
                                    </Col>
                                </Row>
                            )}

                            <Row className="mb-3">
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label>Footer (optional)</Form.Label>
                                        <Form.Control
                                            type="text"
                                            className="whatsapp-input"
                                            placeholder="Enter footer text"
                                            value={footerText}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFooterText(e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label>Buttons (max 3)</Form.Label>
                                        {buttons.map((btn, index) => (
                                            <div key={index} className="mb-3 p-2 border rounded">
                                                <InputGroup className="mb-2">
                                                    <Form.Control
                                                        type="text"
                                                        value={btn.text || ''}
                                                        readOnly
                                                        className="whatsapp-input"
                                                    />
                                                    <Button
                                                        variant="outline-danger"
                                                        onClick={() => removeButton(index)}
                                                    >
                                                        Remove
                                                    </Button>
                                                </InputGroup>
                                                <div className="small text-muted">
                                                    Type: {btn.type === 'call_to_action' ? 'Call to Action' : 'Quick Reply'}
                                                    {btn.type === 'call_to_action' && (
                                                        <>
                                                            {btn.phoneNumber && ` | Phone: ${btn.phoneNumber}`}
                                                            {btn.url && ` | URL: ${btn.url}`}
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                        {buttons.length < 10 && (
                                            <div className="border p-3 rounded">
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Button Type</Form.Label>
                                                    <Form.Select
                                                        className="whatsapp-input"
                                                        value={newButtonType}
                                                        onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                                                            setNewButtonType(e.target.value as 'none' | 'call_to_action' | 'quick_reply')
                                                        }
                                                    >
                                                        <option value="none">None</option>
                                                        <option value="quick_reply">Quick Reply</option>
                                                        <option value="call_to_action">Call to Action</option>
                                                    </Form.Select>
                                                </Form.Group>
                                                {newButtonType === 'quick_reply' && (
                                                    <>
                                                        <Row>
                                                            <Col>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Button Type</Form.Label>
                                                                    <Form.Select
                                                                        className="whatsapp-input">
                                                                        <option value="custom">custom</option>
                                                                        <option value="Preconfigured Response">Preconfigured Response</option>
                                                                    </Form.Select>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Button Text</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        value={newButtonText}
                                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setNewButtonText(e.target.value)}
                                                                        className="whatsapp-input"
                                                                        placeholder="Button text"
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                    </>
                                                )}
                                                {newButtonType === 'call_to_action' && (
                                                    <>
                                                        <Row>
                                                            <Col>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Button Type</Form.Label>
                                                                    <Form.Select
                                                                        className="whatsapp-input"
                                                                        value={call_action_type}
                                                                        onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                                                                            setCall_action_type(e.target.value as 'SITE' | 'CALL')
                                                                        }
                                                                    >
                                                                        <option value="SITE">Visit Site</option>
                                                                        <option value="CALL">Call PhoneNumber</option>
                                                                    </Form.Select>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Button Text</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        value={newButtonText}
                                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setNewButtonText(e.target.value)}
                                                                        className="whatsapp-input"
                                                                        placeholder="Button text"
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            {call_action_type === 'CALL' && (
                                                                <Col>
                                                                    <Form.Group className="mb-3">
                                                                        <Form.Label>Phone Number (optional)</Form.Label>
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={newButtonPhone}
                                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setNewButtonPhone(e.target.value)}
                                                                            className="whatsapp-input"
                                                                            placeholder="+1234567890"
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                            )}
                                                            {call_action_type === 'SITE' && (
                                                                <Col>
                                                                    <Form.Group>
                                                                        <Form.Label>Website URL</Form.Label>
                                                                        <Form.Control
                                                                            type="url"
                                                                            value={newButtonUrl}
                                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setNewButtonUrl(e.target.value)}
                                                                            className="whatsapp-input"
                                                                            placeholder="https://example.com"
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                            )}
                                                        </Row>
                                                    </>
                                                )}

                                                <Button
                                                    variant="outline-primary"
                                                    onClick={addButton}
                                                    className="mt-3"
                                                    disabled={!newButtonText.trim()}
                                                >
                                                    Add Button
                                                </Button>
                                            </div>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>

                            <div className="text-end mt-4">
                                <Button variant="light" className="me-2">
                                    Cancel
                                </Button>
                                <Button variant="primary" type="submit">
                                    Submit Template
                                </Button>
                            </div>
                        </Form>
                    </Card.Body>
                </Col>
                <Col md={4}>
                <Card.Header className="bg-secondary d-flex justify-content-between align-items-center">
                        <h5 className="mb-0 text-white">Template Preview</h5>
                    </Card.Header>
                    <Card.Body>
                        {/* Preview Section */}
                        <div className="mt-2">
                            {/* <h5 className="mb-3">Template Preview</h5> */}
                            <div className="whatsapp-preview-container">
                                <div className="whatsapp-preview">
                                    <div className="whatsapp-header-preview">
                                        <div className="whatsapp-profile-pic">
                                            <img src="https://mercury.skynyxserver.com/git_projects/old/skynyx.png" alt="" />
                                        </div>
                                        <div className="whatsapp-contact">
                                            <div className="whatsapp-contact-name">SKYNYX TECHNOLOGIES</div>
                                            <div className="whatsapp-contact-status">online</div>
                                        </div>
                                        <div className="whatsapp-menu">
                                            <i className="fas fa-ellipsis-v"></i>
                                        </div>
                                    </div>
                                    <div className="whatsapp-message-preview">
                                        {headerType !== 'None' && (
                                            <div className="whatsapp-template-header">
                                                {headerType === 'TEXT' ? (
                                                    // <div className="whatsapp-text-header">{renderHeaderPreviewText(headerText) || 'Header text will appear here'}</div>
                                                    <div className="whatsapp-text-header" dangerouslySetInnerHTML={{ __html: renderHeaderPreviewText(headerText) }} />
                                                ) : headerType === 'IMAGE' ? (
                                                    <div className="whatsapp-image-header">
                                                        {headerFile ? (
                                                            <img
                                                                src={URL.createObjectURL(headerFile)}
                                                                alt="Header preview"
                                                            />
                                                        ) : (
                                                            <div className="whatsapp-image-placeholder">[Image Preview]</div>
                                                        )}
                                                    </div>
                                                ) : headerType === 'VIDEO' ? (
                                                    <div className="whatsapp-video-header">
                                                        {headerFile ? (
                                                            <video controls>
                                                                <source src={URL.createObjectURL(headerFile)} />
                                                            </video>
                                                        ) : (
                                                            <div className="whatsapp-video-placeholder">[Video Preview]</div>
                                                        )}
                                                    </div>
                                                ) : headerType === 'DOCUMENT' ? (
                                                    <div className="whatsapp-document-header">
                                                        {headerFile ? (
                                                            <div className="whatsapp-document-preview">
                                                                <div className="whatsapp-document-icon">
                                                                    <i className="fas fa-file-alt"></i>
                                                                </div>
                                                                <div className="whatsapp-document-name">
                                                                    {headerFile.name}
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="whatsapp-document-placeholder">[Document Preview]</div>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <div className="whatsapp-location-header">
                                                        <div className="whatsapp-location-map">
                                                            <i className="fas fa-map-marker-alt"></i>
                                                        </div>
                                                        <div className="whatsapp-location-details">
                                                            <div className="whatsapp-location-name">Location</div>
                                                            <div className="whatsapp-location-address">Address will appear here</div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        <div className="whatsapp-template-body">
                                            {bodyText ? (
                                                <div dangerouslySetInnerHTML={{ __html: renderPreviewText(bodyText) }} />
                                            ) : (
                                                'Body text will appear here'
                                            )}
                                        </div>
                                        {footerText && (
                                            <div className="whatsapp-template-footer">
                                                {footerText}
                                            </div>
                                        )}
                                        {buttons.length > 0 && (
                                            <div className="whatsapp-template-buttons">
                                                {buttons.map((button, index) => renderButtonPreview(button, index))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card.Body>
                </Col>
            </Row>
        </Card >
    );
};

export default AddNewTemplate;